import { apiClient } from './client';
import { Master, UsuarioAdmin } from '../types';

export function loginMaster(email: string, senha: string): Promise<Master> {
  return apiClient.post('/master/login', { email, senha }).then((res) => res.data.master);
}

export function logoutMaster(): Promise<{ ok: boolean }> {
  return apiClient.post('/master/logout').then((res) => res.data);
}

export function buscarMasterAtual(): Promise<Master | null> {
  return apiClient.get('/master/me').then((res) => res.data.master);
}

export function listarUsuarios(): Promise<UsuarioAdmin[]> {
  return apiClient.get('/master/usuarios').then((res) => res.data.usuarios);
}

export function alterarAtivoUsuario(id: number, ativo: boolean): Promise<UsuarioAdmin> {
  return apiClient.put(`/master/usuarios/${id}/ativo`, { ativo }).then((res) => res.data.usuario);
}
